// Rutas alcanzables SIN pasar por los gates de la app. Fuente única: antes vivía
// duplicada en `App.js` (sidebar de escritorio) y en `LaunchGate.js` (waitlist), y
// las dos copias se olvidaban de las páginas de cumplimiento — el cliente que
// pulsaba "política de reembolso" con la waitlist activa quedaba atrapado en la
// pantalla de espera, y en escritorio esas páginas salían con la sidebar alrededor.
export const PUBLIC_PATHS = [
  '/', '/login', '/reset-password',
  // Páginas legales y de cumplimiento (enlazadas desde el pie del landing y desde
  // los tres checkouts; son las que revisa Azul).
  '/privacy', '/terms', '/payment-security', '/refunds', '/delivery', '/contact',
  '/rankings', '/pricing',
];

// Rutas públicas con parámetro. NO incluye '/preview/': eximirlo era un bypass no
// intencional del gate de lanzamiento.
export const PUBLIC_PREFIXES = ['/workshop/profile/'];

export function isPublicPath(pathname) {
  if (!pathname) return false;
  return PUBLIC_PATHS.includes(pathname) || PUBLIC_PREFIXES.some(p => pathname.startsWith(p));
}
